/* Concierge B et B : apparition douce des sections au scroll */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  var sections = document.querySelectorAll('main .shopify-section');
  if (!sections.length) return;

  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('cbb-in');
          io.unobserve(entry.target);
        }
      });
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.05 }
  );

  sections.forEach(function (el) {
    var rect = el.getBoundingClientRect();
    /* déjà visible au chargement → pas d'animation (évite tout flash) */
    if (rect.top < window.innerHeight * 0.9) return;
    el.classList.add('cbb-anim');
    io.observe(el);
  });
})();
